import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { NavLink, useLocation } from 'react-router-dom';

import { authService } from '@S';
import { useGlobalStore } from '@stores/globalStore';

import packageJson from '/package.json';

const Navbar = () => {
  const toggleSubMenu = (e) => {
    e.preventDefault();
    const el = e.target.nextSibling;
    el.classList.toggle('active');
  };

  const location = useLocation();

  const navigationData = useGlobalStore((state) => state.navigationData);

  const env = process.env.ENVIRONMENT;

  // Scroll to the top when the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleMobileNavClick = () => {
    // Check if device is mobile (width <= 768px)
    if (window.innerWidth <= 768) {
      document.body.classList.add('sidebar-collapsed');
    }
  };

  return (
    <div className="nav-wrapper expanded">
      <span className="app-version">v{packageJson.version}</span>
      <nav>
        <ul>
          {navigationData.map((link, index) => {
            if (link.enabled === false) return null;
            if (
              !link.roles.some(
                (item) => item.role_type === authService.currentUserRoleCode,
              )
            ) {
              return null;
            }
            if (!link.environment.some((item) => item.name === env)) {
              return null;
            }
            return (
              <li key={index}>
                <NavLink
                  activeClassName="active"
                  onClick={handleMobileNavClick}
                  to={`${link.title.toLowerCase() === 'dsr' ? link.path + '/' + dayjs().format('YYYY-MM-DD') : link.path}`}
                >
                  <span className={`fa fa-duotone fa-${link.icon}`} />
                  <span>{link.title}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="wave-container">
        <div className="navbar-logo" />
        <div className="wave-wrapper">
          <div className="wave" />
          <div className="wave" />
        </div>
      </div>
    </div>
  );
};

export default Navbar;

export { Navbar };
